(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('FlowConfig')?.textContent || '{}');
  const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const locale = config.lang?.startsWith('es') ? 'es-MX' : 'en-US';
  const focusReturn = new WeakMap();
  const quoteDialogs = new Map();
  const toast = (message) => {
    const node = document.querySelector('[data-flow-toast]');
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
    clearTimeout(node.hideTimer);
    node.hideTimer = setTimeout(() => { node.hidden = true; }, 7000);
  };
  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    focusReturn.set(dialog, trigger);
    if (!dialog.open) dialog.showModal();
    const panel = document.querySelector('[data-menu-toggle][aria-expanded=true]');
    if (panel) panel.click();
  };
  const wireDialog = (dialog) => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => focusReturn.get(dialog)?.focus());
  };
  const initializeQuotes = () => document.querySelectorAll('[data-quote-disclosure]').forEach(details => {
    if (details.dataset.ready) return;
    details.dataset.ready = 'true';
    if (window.Shopify?.designMode) { details.open = true; return; }
    const panel = details.querySelector('[data-quote-panel]');
    const summary = details.querySelector('summary');
    if (!panel || !summary) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'flow-dialog';
    const heading = document.createElement('h2');
    heading.id = 'QuoteTitle-' + quoteDialogs.size;
    heading.textContent = panel.dataset.title || config.quote;
    dialog.setAttribute('aria-labelledby', heading.id);
    const header = document.createElement('div');
    header.className = 'flow-dialog__header';
    const close = document.createElement('button');
    close.type = 'button';
    close.dataset.dialogClose = '';
    close.textContent = '×';
    close.setAttribute('aria-label', config.close);
    header.append(heading, close);
    dialog.append(header, panel);
    document.body.append(dialog);
    wireDialog(dialog);
    quoteDialogs.set(details, dialog);
    details.open = false;
    summary.addEventListener('click', event => { event.preventDefault(); openDialog(dialog, summary); });
  });
  const reservation = (trigger) => {
    const dialog = document.getElementById('ReservationDialog');
    openDialog(dialog, trigger);
    const fallback = dialog.querySelector('a.button');
    if (trigger.href) fallback.href = trigger.href;
    const widget = dialog.querySelector('[data-reservation-widget]');
    if (widget.dataset.loaded) return;
    widget.dataset.loaded = 'true';
    const script = document.createElement('script');
    script.src = 'https://www.opentable.com.mx/widget/reservation/loader?rid=1287334&type=standard&theme=standard&color=1&dark=false&iframe=true&domain=commx&lang=' + locale + '&newtab=false&ot_source=Restaurant%20website&ot_campaign=Web%20Complete%20' + (locale === 'es-MX' ? 'SPA' : 'ENG') + '&cfe=true';
    script.onerror = () => { widget.style.minHeight = '0'; widget.dataset.loaded = ''; };
    widget.append(script);
  };
  let cartQueue = Promise.resolve();
  let pendingCartChanges = 0;
  const syncCartBusy = () => document.querySelectorAll('[data-cart-fragment]').forEach(fragment => {
    if (pendingCartChanges) fragment.setAttribute('aria-busy', 'true');
    else fragment.removeAttribute('aria-busy');
    fragment.querySelectorAll('[name="checkout"]').forEach(button => {
      if (pendingCartChanges) {
        if (!button.dataset.cartPending) button.dataset.wasDisabled = String(button.disabled);
        button.dataset.cartPending = 'true';
        button.disabled = true;
      } else if (button.dataset.cartPending) {
        button.disabled = button.dataset.wasDisabled === 'true';
        delete button.dataset.cartPending;
        delete button.dataset.wasDisabled;
      }
    });
  });
  const setCount = count => document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
  const refreshCart = async html => {
    if (!html) {
      const response = await fetch(root + '?section_id=cart-drawer', {headers:{Accept:'text/html'}});
      if (!response.ok) throw new Error(config.cart_error);
      html = await response.text();
    }
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fragment = parsed.querySelector('[data-cart-fragment]');
    if (!fragment) throw new Error(config.cart_error);
    document.querySelector('[data-cart-content]').replaceChildren(fragment);
    setCount(Number(fragment.dataset.itemCount));
    syncCartBusy();
  };
  const mutateCart = async (url, body) => {
    const response = await fetch(root + url, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || config.cart_error);
    await refreshCart(data.sections?.['cart-drawer']);
    return data;
  };
  const changeCart = (key, quantity) => {
    pendingCartChanges += 1;
    syncCartBusy();
    cartQueue = cartQueue.catch(() => {}).then(() => mutateCart('cart/change.js', {id:key,quantity,sections:['cart-drawer'],sections_url:window.location.pathname})).catch(error => {
      const status = document.querySelector('[data-cart-status]');
      if (status) status.textContent = error.message;
      toast(error.message);
    }).finally(() => { pendingCartChanges -= 1; syncCartBusy(); });
  };
  const changeQuantity = (control, direction) => {
    const input = control.querySelector('input');
    if (!input) return;
    const min = Number(input.min || 1), step = Number(input.step || 1), max = input.max ? Number(input.max) : Infinity;
    const next = Math.max(min, Math.min(max, (Number(input.value) || min) + direction * step));
    input.value = next;
    input.dispatchEvent(new Event('change', {bubbles:true}));
  };
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-dialog-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const step = event.target.closest('[data-step]');
    if (step) { changeQuantity(step.closest('.flow-quantity'), Number(step.dataset.step)); return; }
    const scroll = event.target.closest('[data-scroll-target]');
    if (scroll) {
      const track = document.getElementById(scroll.dataset.scrollTarget);
      track?.scrollBy({left:Number(scroll.dataset.scrollDirection) * (track.firstElementChild?.getBoundingClientRect().width + 16 || track.clientWidth),behavior:reduced.matches?'auto':'smooth'});
      return;
    }
    const remove = event.target.closest('[data-remove-key]');
    if (remove) { event.preventDefault(); changeCart(remove.dataset.removeKey,0); return; }
    const cart = event.target.closest('[data-open-cart]');
    if (cart && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault(); openDialog(document.getElementById('CartDialog'),cart);
      cartQueue = cartQueue.catch(() => {}).then(() => refreshCart()).catch(() => toast(config.cart_error));
      return;
    }
    const again = event.target.closest('[data-open-repurchase], a[href="#BuyAgain"]');
    if (again) { event.preventDefault(); openDialog(document.getElementById('BuyAgain'),again); return; }
    const quote = event.target.closest('[data-open-quote]');
    if (quote && quoteDialogs.size) { event.preventDefault(); openDialog(quoteDialogs.values().next().value,quote); return; }
    const anchor = event.target.closest('a[href]');
    if (anchor && document.querySelector('[data-reserve-modal=true]') && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      const url = new URL(anchor.href);
      if (/(^|\.)opentable\.com(\.mx)?$/.test(url.hostname) && !url.searchParams.has('experienceId') && (url.pathname.startsWith('/r/') || url.searchParams.has('rid'))) { event.preventDefault(); reservation(anchor); }
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-input]')) {
      if (!event.target.checkValidity()) { event.target.reportValidity(); return; }
      changeCart(event.target.closest('[data-cart-quantity]').dataset.key, Number(event.target.value));
    }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-quick-add]')) return;
    event.preventDefault();
    if (form.dataset.pending) return;
    form.dataset.pending = 'true';
    const button = form.querySelector('[type=submit]');
    button.disabled = true;
    const values = new FormData(form);
    const payload = {items:[{id:Number(values.get('id')),quantity:Number(values.get('quantity') || 1)}],sections:['cart-drawer'],sections_url:window.location.pathname};
    pendingCartChanges += 1;
    syncCartBusy();
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || config.cart_error);
      try { await refreshCart(data.sections?.['cart-drawer']); }
      catch { window.location.assign(root + 'cart'); return; }
      openDialog(document.getElementById('CartDialog'),button);
    }).catch(error => toast(error.message)).finally(() => {
      pendingCartChanges -= 1;
      syncCartBusy();
      delete form.dataset.pending;
      button.disabled = false;
    });
  });
  const dateKey = date => date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2,'0') + '-' + String(date.getDate()).padStart(2,'0');
  const todayKey = () => { const parts = new Intl.DateTimeFormat('en-CA',{timeZone:'America/Mazatlan',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()); const value = type => parts.find(part => part.type === type).value; return value('year') + '-' + value('month') + '-' + value('day'); };
  const validDate = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') && dateKey(new Date(value + 'T12:00:00')) === value;
  const validTime = value => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value || '');
  const getEvents = () => {
    const source = document.querySelector('[data-global-events]');
    if (!source) return [];
    return Array.from(source.content.querySelectorAll('[data-event-start]')).map(node => {
      const start = validDate(node.dataset.eventStart) ? node.dataset.eventStart : '';
      const end = validDate(node.dataset.eventEnd) && node.dataset.eventEnd >= start ? node.dataset.eventEnd : start;
      const time = validTime(node.dataset.eventTime) ? node.dataset.eventTime : '';
      return {node,start,end,time};
    }).sort((a,b) => (a.start || '9999').localeCompare(b.start || '9999'));
  };
  const cardFor = entry => {
    const card = entry.node.cloneNode(true);
    const label = card.querySelector('[data-event-date]');
    if (entry.start) {
      const format = date => new Intl.DateTimeFormat(locale,{day:'numeric',month:'short',year:'numeric'}).format(new Date(date+'T12:00:00'));
      label.textContent = format(entry.start) + (entry.end !== entry.start ? ' — '+format(entry.end) : '');
      if (entry.time) label.textContent += ' · ' + new Intl.DateTimeFormat(locale,{hour:'numeric',minute:'2-digit'}).format(new Date(entry.start + 'T' + entry.time + ':00'));
    } else if (!label.textContent.trim()) label.textContent = config.undated;
    return card;
  };
  const renderEvents = () => {
    const all = getEvents(), today = todayKey(), month = today.slice(0,7);
    document.querySelectorAll('[data-event-view]:not([data-event-view=calendar])').forEach(view => {
      let entries = all.filter(entry => !entry.end || entry.end >= today);
      if (view.dataset.eventScope === 'month') entries = entries.filter(entry => entry.start && entry.start.slice(0,7) <= month && entry.end.slice(0,7) >= month);
      if (view.dataset.eventView === 'next') entries = entries.filter(entry => entry.start).slice(0,1);
      view.replaceChildren(...entries.map(cardFor));
      if (!entries.length) { const p = document.createElement('p'); p.className='empty-state';p.textContent=config.empty_events;view.append(p); }
    });
    document.querySelectorAll('[data-flow-calendar]').forEach(calendar => {
      if (calendar.dataset.ready) { calendar.paintEvents?.(); return; }
      calendar.dataset.ready = 'true';
      let monthDate = new Date(today + 'T12:00:00');
      monthDate.setDate(1);
      const grid=calendar.querySelector('[data-calendar-grid]'),list=calendar.querySelector('[data-calendar-list]'),status=calendar.querySelector('[data-calendar-status]');
      const week=calendar.querySelector('[data-calendar-week]');
      for(let index=0;index<7;index++){const label=document.createElement('span');label.textContent=new Intl.DateTimeFormat(locale,{weekday:'short'}).format(new Date(2024,0,1+index));week.append(label);}
      const paint = selected => {
        const monthKey = dateKey(monthDate).slice(0,7);
        calendar.querySelector('[data-calendar-heading]').textContent=new Intl.DateTimeFormat(locale,{month:'long',year:'numeric'}).format(monthDate);
        const entries=getEvents().filter(entry => entry.start && entry.start.slice(0,7)<=monthKey && entry.end.slice(0,7)>=monthKey);
        const chosen=selected?entries.filter(entry=>entry.start<=selected&&entry.end>=selected):entries;
        list.replaceChildren(...chosen.map(cardFor));
        const undated=getEvents().filter(entry=>!entry.start);
        if(!selected) list.append(...undated.map(cardFor));
        status.textContent=chosen.length?'':config.calendar_empty;
        grid.replaceChildren();
        const offset=(monthDate.getDay()+6)%7, days=new Date(monthDate.getFullYear(),monthDate.getMonth()+1,0).getDate();
        for(let index=0;index<offset;index++){const blank=document.createElement('span');blank.setAttribute('aria-hidden','true');grid.append(blank);}
        for(let day=1;day<=days;day++){
          const key=dateKey(new Date(monthDate.getFullYear(),monthDate.getMonth(),day)),matches=entries.filter(entry=>entry.start<=key&&entry.end>=key);
          const button=document.createElement('button');button.type='button';button.className='flow-calendar__day';button.textContent=day;button.dataset.today=String(key===today);button.dataset.hasEvents=String(matches.length>0);button.disabled=matches.length===0;button.setAttribute('aria-pressed',String(key===selected));button.setAttribute('aria-label',new Intl.DateTimeFormat(locale,{dateStyle:'full'}).format(new Date(key+'T12:00:00'))+(matches.length?' · '+matches.map(entry=>entry.node.dataset.eventTitle).join(', '):''));
          if(matches.length){const count=document.createElement('small');count.textContent=matches.length+' '+(locale==='es-MX'?'evento(s)':'event(s)');button.append(count);button.addEventListener('click',()=>paint(key===selected?null:key));}
          grid.append(button);
        }
      };
      calendar.querySelectorAll('[data-calendar-shift]').forEach(button=>button.addEventListener('click',()=>{monthDate.setMonth(monthDate.getMonth()+Number(button.dataset.calendarShift));paint();}));
      calendar.querySelector('[data-calendar-today]').addEventListener('click',()=>{monthDate=new Date(todayKey()+'T12:00:00');monthDate.setDate(1);paint();});
      calendar.paintEvents = () => paint();
      paint();
    });
  };
  const initializeVideos = () => {
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      const video=entry.target;
      if(entry.isIntersecting && !reduced.matches && video.dataset.userPaused!=='true') video.play().catch(()=>{});
      else if(!entry.isIntersecting) video.pause();
    }),{threshold:.25});
    document.querySelectorAll('[data-flow-video]').forEach(video=>{
      if(video.dataset.ready)return;video.dataset.ready='true';observer.observe(video);
      const button=video.parentElement.querySelector('[data-video-toggle]');
      video.addEventListener('timeupdate',()=>{if(video.currentTime>=10 && video.duration>10) video.currentTime=0;});
      video.addEventListener('play',()=>{button.textContent='Ⅱ';button.setAttribute('aria-label',config.video_pause);});
      video.addEventListener('pause',()=>{button.textContent='▶';button.setAttribute('aria-label',config.video_play);});
      button.addEventListener('click',()=>{if(video.paused){video.dataset.userPaused='false';video.dataset.userPlay='true';video.play().catch(()=>{});}else{video.dataset.userPaused='true';video.pause();}});
    });
    document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-flow-video]').forEach(video=>video.pause());});
  };
  const initialize = () => {
    document.querySelectorAll('dialog').forEach(wireDialog);
    initializeQuotes();renderEvents();initializeVideos();
    if (window.innerWidth>=990) document.querySelectorAll('.flow-store-sidebar .filters').forEach(details=>{details.open=true;});
  };
  initialize();
  if (new URLSearchParams(window.location.search).get('quote') === 'sent') {
    toast(config.quote_sent);
    const clean = new URL(window.location.href); clean.searchParams.delete('quote'); history.replaceState(null,'',clean);
  }
  reduced.addEventListener('change', () => { if (reduced.matches) document.querySelectorAll('[data-flow-video]').forEach(video=>video.pause()); });
  document.addEventListener('click', event => document.querySelectorAll('.flow-nav-dropdown[open]').forEach(details=>{if(!details.contains(event.target))details.open=false;}));
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',event=>{
    quoteDialogs.forEach((dialog,details)=>{if(event.target.contains(details)){dialog.close();dialog.remove();quoteDialogs.delete(details);}});
 
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.flow-nav-dropdown[open]').forEach(details=>details.open=false);});
})();
